

import axios, { type AxiosResponse } from 'axios';
import _ from 'lodash'

const isNiceloopExtensionInstalled = (() => {
    if (typeof window === 'undefined') return false
    try {
        return window.localStorage.getItem('niceloop_chrome_extension_installed') === 'true'
    } catch {
        return false
    }
})()

export default class ThermalPrinterBase {
    apiUrl: string = "http://localhost:9000/api/command";
    path: string = "/"
    print_data = null

    constructor(_path?: string) {
        this.path = _path || "/"
    }


    // ตรวจสอบ item ที่ใช้
    getPrintersThatUsed(items: any) {
        const printers: any = []
        items.forEach((item: any) => {
            printers.push(item.printer)
        })
        return  _.compact(printers)
    }

    onSendRequest(){
        let url = this.apiUrl + this.path
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: url,
            headers: {
              'Content-Type': 'application/json'
            }
          };

          const dataString = this.print_data ? JSON.stringify(this.print_data) : ""
          if(this.print_data){
            config['data'] = dataString
          }

          // If the legacy Niceloop Chrome extension is installed, route via
          // window.postMessage so it can proxy the call (HTTPS -> extension ->
          // localhost). Otherwise, post directly to the local printer app.
          if (isNiceloopExtensionInstalled && typeof window !== 'undefined') {
            window.postMessage({
                type: "NICELOOP_APP_PRINTER",
                text: "Hello from the webpage!",
                payload: {
                    data: dataString,
                    url: url,
                },
            }, "*")
            return
          }

          axios.request(config)
          .then((response) => {
            console.log(JSON.stringify(response.data));
          })
          .catch((error) => {
            console.log(error);
          });

    }

    openDrawer(){
        this.onSendRequest();
    }

    print() {
       this.onSendRequest();
    }
  
}